module.exports = __webpack_public_path__ + "static/media/file-image-o.52a91787.svg";